import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Container = styled.div`
	width: 100%;
	height: calc(100vh - 48px);
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

export const MainMessage = styled.div`
	font-size: 33px;
	font-weight: 500;
	color: ${colors.grey8};
	display: flex;
	justify-content: center;
	text-align: center;
	width: 672px;
	margin: 24px 0;
`;

export const SecondaryMessage = styled.div`
	margin: 24px 0;
	font-size: 16px;
	font-weight: 400;
	color: ${colors.grey5};
`;

export const EmptyImage = styled.img``;
